import { ol_Feature } from "@omnia/exports/openlayers";
import { Layer } from "../layer";
import { IMapAutoEditConfig, IMapContainer } from "../types";

export enum EditMode {
    Split = 1,
    Merge = 2,
    Draw = 3
}

export interface IEditMap extends IMapContainer {

    cancelEdit();
    canCommit(): boolean;
    commitEdit(): any;
    startDrawingNewFeature(layer: Layer, type: string);
    startEditFeature(feature: any, fitExtent: boolean);

    enableMultipleSelection: boolean;
    autoEdit(autEdit: IMapAutoEditConfig);

    selectFeatures(features: any[]);
    clearSelection();
    watchSelection(watcher: (selection: any) => void);
    unwatchSelection(watcher: (selection: any) => void);

    removeFeatures(features: any[]);

}

export interface IEditContext {

    map: IEditMap;

    outerGeometry: any;

    layer: Layer;

    zones: IEditZone[];
    createNewZoneWithGeometry(geometry: any);
    removeZone(zone: IEditZone);

    onEditModeChanged?(mode: EditMode);

    enablePolygonDrawingTools?: boolean;

}


export interface IEditZone {

    feature: ol_Feature;
    value: any;

    getDescription(): string;


}
